import React from "react";
import { Button, withStyles } from "@material-ui/core";

export const ButtonSave = ({ text, type, addId }) => {
  return (
    <Button
      type={type}
      fullWidth
      variant="contained"
      style={{
        paddingTop: "16px",
        paddingBottom: "13px",
        marginTop: "16px",
        textTransform: "none",
        width: "100%",
        background: "#0f70b7",
        color: "white",
        marginBottom: "20px",
        "&:hover": { color: "#0f70b7", background: "#daa900" },
      }}
    >
      {addId ? "EDITAR" : text}
    </Button>
  );
};

export const ButtonCancel = ({ onClick }) => {
  return (
    <Button
      type="button"
      fullWidth
      onClick={onClick}
      variant="contained"
      color="secondary"
      style={{
        paddingTop: "16px",
        paddingBottom: "13px",
        marginTop: "16px",
        textTransform: "none",
        width: "100%",
        background: "#DC5A3E",
        color: "white",
        marginBottom: "20px",
        "&:hover": { color: "#0f70b7", background: "#BA472E" },
      }}
    >
      CANCELAR
    </Button>
  );
};

export const ColorButton = withStyles((theme) => ({
  root: {
    color: "#ffffff",
    width: "auto",
    height: "35px",
    backgroundColor: "#7EBDCE",
    "&:hover": {
      backgroundColor: "#7EBDCE",
    },
  },
}))(Button);

export const BorderGreenButton = withStyles((theme) => ({
  root: {
    color: "#666666",
    border: "solid 1px",
    height: "35px",
    background: "#ffffff",
    "&:hover": { color: "#099F9F", background: "#ffffff" },
  },
}))(Button);

export const BorderRedButton = withStyles((theme) => ({
  root: {
    color: "#B00020",
    border: "solid 1px",
    height: "35px",
    background: "#ffffff",
    "&:hover": { color: "#ffffff", background: "#B00020" },
  },
}))(Button);

export const ButtonRegional = withStyles((theme) => ({
  root: {
    color: "#ffffff",
    width: 130,
    height: "35px",
    backgroundColor: "#666666",
    "&:hover": {
      backgroundColor: "#098B8B",
    },
  },
}))(Button);
